export const DoneIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <rect width="14" height="14" rx="7" fill="white" />
            <path
                d="M3.39062 7.84247L6.03824 9.99036C6.26567 10.1749 6.60225 10.1253 6.76683 9.88306L10.6128 4.22217"
                stroke="#42C27D"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    )
}
